import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import type { Props } from './TipTapText.Lazy';

const LazyTipTapText = dynamic(() => import('./TipTapText.Lazy'), {
    ssr: false,
});

const TipTapText: FC<Props> = (props) => <LazyTipTapText {...props} />;

export { TipTapText };
